 <div class="db-workspace-settings__wrapper">
  <div class="db-workspace-settings__header">
    <div>
      <h3>{{ 'text_workspaceInfoTitle' | dbText}}</h3>
      <a id="save" class="{{isMobile ? 'ds-btn-s' : 'ds-btn-m'}} ds-btn-blue" (click)="onWorkspaceUpdate()"
         [ngClass]="{'db-button_disabled': loading || workspaceSettings.invalid}">
        <span *ngIf="!loading">{{'text_saveTags' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
  <form class="db-workspace-settings" [formGroup]="workspaceSettings" (ngSubmit)="onWorkspaceUpdate()">
    <div class="db-workspace-settings__section">
      <div class="avatar-wrap">
        <div class="db-workspace-settings__avatar">
          <div class="db-workspace-popup__picture" [ngStyle]="{backgroundColor: workspace.workspaceColor}">
            <div>
                      <span *ngIf="!workspaceSettings.controls['logo'].value">
                        {{workspace?.workspaceName.charAt(0).toUpperCase()}}
                      </span>
              <div *ngIf="workspaceSettings.controls['logo'].value"
                   [ngStyle]="{
                            backgroundImage: 'url(&quot;' + workspaceSettings.controls['logo'].value + '&quot;)'}">
              </div>
            </div>
            <a class="db-upload-icon">
              <input type="file" name="cacheIcon" (change)="onFileChanged($event)" accept="image/*">
              <i class="db-icon db-icon-ds-upload"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="db-workspace-settings__item">
        <div class="db-workspace-settings__item-label">
          <label for="name">{{ 'text_workspaceName' | dbText}}</label>
        </div>
        <input class="db-fc-input" placeholder="Add Workspace Name" type="text" name="name" id="name"
               formControlName="name" x-autocompletetype="name" maxlength="60"
               [style.border-color]="(workspaceSettings.invalid
                       && workspaceSettings.get('name').touched
                       && !workspaceSettings.get('name').hasError('required')) ? '#E95E5B' : null">
        <div class="db-workspace-invalide-note"
             *ngIf="(workspaceSettings.invalid && workspaceSettings.get('name').touched
                     && !workspaceSettings.get('name').hasError('required'))"
             [innerHTML]="'text_invalidWorkspaceName' | dbText">
        </div>
      </div>
    </div>
  </form>
</div>
